export interface ExaminationSupply {

    examinationSupplyMaster?: ExaminationSupplyMaster,
    examinationSupplyDetails?: ExaminationSupplyDetails[]
}


export interface ExaminationSupplyMaster {

    serial: number,
    examinationDate: Date,
    supSupplierCode: number,
    poOrderSupplierCode: number,
    storeCode: number,
    status: number,
    examinationType: number;
    handNumber: number;

}
export interface ExaminationSupplyDetails {

    serial: number,
    stpExaminationOrderMasterSerial: number,
    itemCode: number,
    unitCode: number,
    supplyQty: number,
    acceptQty: number,
    rejectQty: number,
    giftFlag: number,
    quantity: number,
    patchCodeStr: number,
    poOrderSupplyMasterSerial: number,
    remain: number,
    smallUnitCode: number,
    reasonOfReject: string
}
